import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const PatternsHeader = () => {
  return (
    <div className="row">
      <div className="col-md-6">
        <Link to="/profiles" className="btn btn-light btn-sm mb-3 float-left">
          <FormattedMessage
            id="patterns.header.backToProfiles"
            defaultMessage="Back to profiles"
          />
        </Link>
      </div>
      <div className="col-md-6" />
    </div>
  );
};

export default PatternsHeader;
